import request from '@/services/request';
import {baseApi} from '../config'

/**
 * @description 判断当前用户是否有订阅权限
 */
export const memberLife=(params:any)=>{
  return request.post(`${baseApi}/uv/article/period/memberLife`,params)
}
/**
 * @description 按月份返回当前报纸该月份存在的期次列表
 */
export const dateList=(params:any)=>{
  return request.post(`${baseApi}/uv/article/period/date`,params)
}
/**
 * @description 根据期次查询(根据权限是否返回版面图)
 */
export const periodTimeWithLife=(params:any)=>{
  return request.post(`${baseApi}/uv/article/period/periodTimeWithLife`,params)
}
/**
 * @description 根据期次查询(无订阅也可返回，没有版面图链接)
 */
export const periodTime=(params:any)=>{
  return request.post(`${baseApi}/uv/article/period/periodTime`,params)
}
/**
 * @description 根据版面id返回文章列表
 */
export const editionId=(params:any)=>{
  return request.post(`${baseApi}/uv/article/article/editionId`,params)
}
/**
 * @description 文章详情
 */
export const articleId=(params:any)=>{
  return request.post(`${baseApi}/uv/article/article/articleId`,params)
}